import service from "@/store/services/opciones-service";

const state = {
  list: {},
  opcion: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, opcion) => {
    state.opcion = opcion;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },


  update({ commit, dispatch }, params) {
    return service.update(params).then(opcion => {
      commit("SET_RESOURCE", opcion);
    });
  },
  
};

const getters = {
  list: state => state.list,
  update: state => state.opcion,
  listTotal: state => state.meta.page.total,
  opcion: state => state.opcion,
  dropdown: state => {
    return state.list.map(opcion => ({
      id: opcion.id,
      clave: opcion.clave,
      valor: opcion.valor
    }));
  }
};

const opciones = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default opciones;
